// import React, { Fragment, useEffect, useState } from "react";
// import "./Cart.css";
// import { useDispatch, useSelector } from "react-redux";
// import CartItems from "./CartItems";
// import {
//   addToCart,
//   removeCartItem,
//   getCartItems,
//   getGuestCartItems,
//   sendCartItemsToPersist,
//   addCartItemsToPersist,
// } from "../../../redux/actions/cartAction";
// import {getSaveForLaterItems, moveItemToSaveForLater, moveItemToCart} from "../../../redux/actions/saveForLaterActions";
// import Button from '@mui/material/Button';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import Loader from "../../layout/Loader/Loader";
// import EmptyCart from "./EmptyCart";
// import { useNavigate, useParams } from "react-router-dom";
// import PriceDetails from "../../Pages/cartpage/PriceDetails";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { getAddress } from "../../../redux/actions/addressActions";
// import { flexbox } from "@mui/system";
// import { TextField } from "@mui/material";
// import { zoneCodes } from "../productPages/zoneCodes";
// import CartPriceDetails from "./CartPriceDetails";
// import { isLoggedIn } from '../../../authUtils';
// import CheckoutHeader from "../../layout/CheckoutHeader";

// // const displayCart = () => {
// //   // Check if user is logged in
// //   if (isLoggedIn()) {
// //     // If logged in, display cart items for logged in user
// //     const cartItems = getCartItems();
// //     console.log(`Cart items for logged in user: ${cartItems}`);
// //   } else {
// //     // If not logged in, display cart items for guest user
// //     const cartItems = getGuestCartItems();
// //     console.log(`Cart items for guest user: ${cartItems}`);
// //   }
// // }

// function Cart(props) {
//   const { slModalOpen } = props;
//   const cart = useSelector((state) => state.cart);
//   const savedItems = useSelector((state) => state.saveForLater.savedItems);
//   const loading = cart.loading;
//   // const  isLoggedIn  = useSelector((state) => state.user.isLoggedIn);
//   const loggedIn = isLoggedIn();

// console.log(cart.priceDetails);
//   const { address } = useSelector(
//     (state) => state.address
//   );

//   console.log({address});

//   const [cartItems, setCartItems] = useState(cart.cartItems);
//   const [priceDetails, setPriceDetails] = useState(cart.priceDetails);

//   const dispatch = useDispatch();

//   const navigate = useNavigate();

//   useEffect(() => {
//     setCartItems(cart.cartItems);
//   }, [cart.cartItems, cart.fetchedCartItems]);

//   useEffect(() => {
//     setPriceDetails(cart.priceDetails);
//   }, [cart.priceDetails, cart.fetchedCartItems]);

//   useEffect(() => {

//     dispatch(getCartItems());
//   }, []);

//   useEffect(() => {
//     dispatch(getSaveForLaterItems());
//   }, [getSaveForLaterItems]);

//   console.log(cart);

//   const onQtyIncrement = (_id, qty) => {
//     const { name, description, sellingPrice, price, markedPrice, img, images, stock } = cartItems[_id];
//     dispatch(
//       addToCart({ _id, name, sellingPrice, markedPrice, description, img, images, stock, price }, 1))
//     };

//     const onQtyDecrement = (_id) => {
//       const { name, description, sellingPrice, price, markedPrice, stock, img, images } = cartItems[_id];
//       dispatch(
//         addToCart({ _id, name, sellingPrice, markedPrice, description, img, images, stock, price }, -1))
//       };

//       //ENTER PINCODE MODAL

//       const [openPin, setOpenPin] = React.useState(false);

//       const handleClickOpenPin = () => {
//         setOpenPin(true);
//       };

//       const handleClosePin = () => {
//         setOpenPin(false);
//       };

//       const pCode = JSON.parse(window.localStorage.getItem('ulpData'));

//       //SELECT ADDRESS MODAL
//       const [openDltConfModal, setOpenDltConfModal] = useState(false);

//       if (setOpenDltConfModal) {
//         document.body.classList.add('active_modal')
//       } else {
//         document.body.classList.remove('active_modal')
//       }

//       const [open, setOpen] = React.useState(false);

//       const handleClickOpen = () => {
//         setOpen(true);
//       };

//       const handleClose = () => {
//         setOpen(false);
//       };

//       const onMoveToSaveForLater = (productId) => {
//         if (loggedIn) {
//           dispatch(moveItemToSaveForLater(productId));
//           dispatch(getSaveForLaterItems());
//         } else {
//           slModalOpen();
//         }
//       };

//       const onMoveBackToCart = (productId) => {
//         dispatch(moveItemToCart(productId));
//         dispatch(getSaveForLaterItems());
//       };

//   const diffToast = () => {
//     toast.info('Item removed from Cart', {
//       position: "top-center",
//       autoClose: 1500,
//       hideProgressBar: true,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//     });
//   }

//   const onRemoveCartItem = (product) => {
//       console.log(product);
//       dispatch(removeCartItem(product));

//     diffToast(toast.info);
//   };

//   //PINCODE CHECK BUTTON LOGIC

//   const [enteredPin, setEnteredPin] = useState('')
//   const shouldAddEventHandler = true;
//   const handleClick = event => {
//     if (zoneCodes.includes(parseInt(enteredPin))) {
//       return true;
//       console.log('true');
//     } else {
//       return false;
//       console.log('false');
//     }
//   };

//   // const ifValidPin = () => {
//   //   if(zoneCodes.includes(parseInt(enteredPin))){
//   //     // return true;
//   //     console.log('true');
//   //   }else {
//   //     // return false;
//   //     console.log('false');
//   //   }
//   // }

//   if (props.onlyCartItems) {
//     return (
//       <Fragment>
//         {loggedIn ?
//         <>
//         {loading && <Loader isLoading={loading}/>}

//           <Fragment>
//             {Object.keys(cartItems).map((key, index) => (
//               <CartItems
//                 key={index}
//                 cartItem={cartItems[key]}
//                 onQuantityInc={onQtyIncrement}
//                 onQuantityDec={onQtyDecrement}
//               />
//             ))}
//           </Fragment>

//         </> : slModalOpen()}
//       </Fragment>
//     );
//   }
//   const goToCheckout = () => {
//     dispatch(addCartItemsToPersist(cartItems));
//     console.log(cartItems)
//     if (loggedIn) {
//       navigate('/checkout');
//     } else {
//       slModalOpen();
//     }
//   }

//   console.log(savedItems);

//   return (
//     <Fragment>
//       <Fragment>
//         {loading && <Loader isLoading={loading}/>}
//           <section className="scroll_cartItems_x">
//           <div className="cart_items_all_inr_cont">
//           {cart && cart.cartItems && Object.keys(cart.cartItems) < 1 ? (
//             <EmptyCart />
//           ) : (

//             <div className="dsktp_cart_main">
//               <div>{cart.totalItems > 0 && <CheckoutHeader/>}</div>
//               <div className="sub_cont_inr">

//                 <div className="cart_left_sec">
//                   <div className="deliver_location">
//                     <div>
//                       {" "}
//                       <div className="location_icon_wrap">
//                       <LocationOnIcon
//                         className="location_icon"
//                         fontSize="small"
//                       />
//                       </div>{" "}
//                       {loggedIn && loggedIn ? (
//                         address &&
//                         address.map(function (adrs, index) {
//                           if (index == 0) {
//                             return (
//                               <div className="adrs_to_deliver_row">
//                                 <div
//                                   key={adrs.id}
//                                   style={{
//                                     fontWeight: "600",
//                                     fontSize: "0.85rem",
//                                   }}
//                                 >
//                                   <div className="deliver_to">
//                                     Deliver to:{" "}
//                                     <span style={{ marginLeft: "5px" }}>
//                                       {adrs.name},{" "}
//                                     </span>
//                                     <span style={{ marginLeft: "5px" }}>
//                                       {" "}
//                                       {adrs?.pinCode}
//                                     </span>
//                                   </div>
//                                   {/* <span className="c_del_adrs">
//                                     {adrs.addressFull}{" "}
//                                   </span> */}
//                                 </div>
//                                 <button onClick={handleClickOpen}>
//                                   Change
//                                 </button>
//                               </div>
//                             );
//                           }
//                         })
//                       ) : (
//                         <div>
//                           {pCode.pinCode === "" ? (
//                             <div className="check_delivery_details">
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                 }}
//                               >
//                                 Check Delivery time & details
//                               </div>
//                               <button onClick={handleClickOpenPin}>
//                                 ENTER PIN CODE
//                               </button>
//                             </div>
//                           ) : (
//                             <span>Deliver to: {pCode?.pinCode}</span>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="cart_items_container">
//                     <div className="cart_items_inr_scroll">
//                       {cartItems &&
//                         Object.keys(cartItems).map((key, index) => (
//                           <CartItems
//                             key={index}
//                             cartItem={cartItems[key]}
//                             onQuantityInc={onQtyIncrement}
//                             onQuantityDec={onQtyDecrement}
//                             onRemoveCartItem={onRemoveCartItem}
//                             onMoveToSaveForLater={onMoveToSaveForLater}
//                           />
//                         ))}
//                     </div>

//                   </div>
//                   {loggedIn && savedItems.length > 0 ? <div className="saveForLater_main">
//                     <div className="saveForLater_container">
//                       <div>
//                         <div className="saveForLter_head">
//                           <span>Saved for Later</span>
//                           <span>( {savedItems.length} )</span>
//                         </div>
//                         <div className="saveForLater_card_main">
//                           {savedItems.length > 0 &&
//                             savedItems.map((item) => (
//                               <div
//                                 key={item.product.id}
//                                 className="saveForLater_card"
//                               >
//                                 <div className="svfrltr_img_cont">
//                                   <img src="../../img/myntrasample.jpg" />
//                                 </div>
//                                 <div className="saveforlater_product_info">
//                                   <div>
//                                     <p>{item.product.name}</p>
//                                     <span className="price_tag">
//                                       <p>₹{item.product.price}</p>
//                                       <p>₹{item.product.markedPrice}</p>
//                                     </span>
//                                     <p>
//                                       <span>Qty:</span> {item.quantity}
//                                     </p>
//                                   </div>
//                                   <div className="svfrltr_btn_cont">
//                                     <button
//                                       onClick={() =>
//                                         onMoveBackToCart(item.product._id)
//                                       }
//                                     >
//                                       Move to Cart
//                                     </button>
//                                     <button>Remove</button>
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                         </div>
//                       </div>
//                     </div>
//                   </div> : null}
//                 </div>

//                 <div className="cart_right_sec">
//                   <div className="cart_p_detail_main_cont">
//                     <CartPriceDetails priceDetails={priceDetails} />
//                     <div
//                       className="cart_checkout_btn"
//                       onClick={() => goToCheckout()}
//                     >
//                       <div className="checkoutBtn">PLACE ORDER</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//           </section>

//       </Fragment>
//       <div>
//         <Dialog
//           open={open}
//           PaperProps={{
//             sx: {
//               width: "28%",
//               padding: '15px',
//             },
//           }}
//           onClose={handleClose}
//           aria-labelledby="alert-dialog-title"
//           aria-describedby="alert-dialog-description"
//           // style={{ overflowX: "scroll", overflowY: "hidden", height: '40vmax', position: 'absolute', top: '100px', }}
//         >
//           <div onClick={handleClose} className="close_mdl_btn">
//             <CloseRoundedIcon fontSize="small" />
//           </div>
//           <DialogTitle
//             className="cAmh"
//             id="alert-dialog-title"
//             style={{
//               fontSize: "1rem",
//               fontWeight: "600",
//               fontFamily: "Philosopher",
//             }}
//           >
//             {"Select Delivery Address"}
//           </DialogTitle>
//           <DialogContent>
//             <DialogContentText
//               className="cAmcI"
//               id="alert-dialog-description"
//               style={{
//                 fontSize: "1rem",
//                 fontFamily: "Philosopher",
//                 color: "black",
//               }}
//             >
//               <div>
//                 {address &&
//                   address.map((adrs) => (
//                     <div
//                       style={{ width: "100%", boxShadow: "none", padding: "0" }}
//                       className="adrs_row_container"
//                       key={adrs.id}
//                     >
//                       <div className="slct_r_button">
//                         <input name="address" type="radio" />
//                       </div>
//                       <div className="adrs_all_info">
//                         <div className="adrs_row_name">
//                           <div>
//                             <span>{adrs.name}, </span>
//                             <span
//                               style={{ fontWeight: "600", fontSize: "0.85rem" }}
//                             >
//                               {adrs?.pinCode}
//                             </span>
//                             <span>{adrs.addressType}</span>
//                           </div>
//                         </div>
//                         <div className="adrs_row_full">
//                           <div>
//                             <span>{adrs.addressFull}, </span>
//                             <span>{adrs.cityDistrict}</span>
//                             <div></div>
//                           </div>
//                         </div>
//                         <div className="adrs_row_btns"></div>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             </DialogContentText>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//               }}
//             >
//               <p
//                 style={{
//                   padding: "8px 0",
//                   borderTop: "0.5px dashed #bcbcbc",
//                   width: "100%",
//                   textAlign: "center",
//                 }}
//               >
//                 OR
//               </p>
//               <p
//                 style={{
//                   fontSize: "0.85rem",
//                   alignSelf: "flex-start",
//                   marginLeft: "10px",
//                   lineHeight: "0.1",
//                 }}
//               >
//                 Check Delivery info by Pincode
//               </p>
//               <div className="pinCheck">
//                 <input
//                   name="pincode"
//                   onInput={(e) => {
//                     if (e.target.value.length > e.target.maxLength)
//                       e.target.value = e.target.value.slice(
//                         0,
//                         e.target.maxLength
//                       );
//                   }}
//                   type="number"
//                   maxlength={6}
//                   placeholder="Enter pincode"
//                 />
//                 <span style={{ fontSize: "0.8rem" }}>SUBMIT</span>
//               </div>
//             </div>
//           </DialogContent>
//         </Dialog>
//       </div>
//       <div>
//         <Dialog open={openPin} onClose={handleClosePin}>
//           <CloseRoundedIcon
//             style={{
//               position: "absolute",
//               right: "10px",
//               top: "10px",
//               fontSize: "medium",
//               cursor: "pointer",
//             }}
//             onClick={handleClosePin}
//           />

//           <DialogTitle style={{ fontSize: "0.9rem" }}>
//             Enter Pincode
//           </DialogTitle>

//           <DialogContent>
//             <div
//               style={{
//                 border: "2px solid gray",
//                 display: "flex",
//                 alignItems: "center",
//                 borderRadius: "5px",
//               }}
//             >
//               <input
//                 autoFocus="true"
//                 style={{
//                   height: "100%",
//                   width: "250px",
//                   border: "none",
//                   outline: "none",
//                   padding: "0 10px",
//                 }}
//                 name="pincode"
//                 onChange={(event) => setEnteredPin(event.target.value)}
//                 // onInput={(e) => {
//                 //   if (e.target.value.length > e.target.maxLength)
//                 //     e.target.value = e.target.value.slice(
//                 //     0,
//                 //     e.target.maxLength
//                 //      );
//                 //   }}
//                 // type="number"
//                 // maxlength={6}
//                 // onChange={event => setZipValue(event.target.value)}
//               />
//               <Button
//                 onClick={shouldAddEventHandler ? handleClick : undefined}
//                 style={{ color: "gray" }}
//               >
//                 CHECK
//               </Button>
//             </div>
//             {/* <DialogContentText>
//           Enter Pincode
//           </DialogContentText> */}
//             {/* <TextField
//             autoFocus
//             margin="dense"
//             id="name"
//             label="Pincode"
//             type="number"
//             fullWidth
//             variant="outlined"
//             size="small"
//             style={{height: '16px', width: '350px'}}

//               onInput = {(e) =>{
//                 e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,6);
//             }}

//           /> */}
//           </DialogContent>
//           <DialogActions
//             style={{ background: "#CDA500", borderTop: "dotted 3px #fff" }}
//           ></DialogActions>
//         </Dialog>
//       </div>
//     </Fragment>
//   );
// }

// export default Cart;

import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetCartItemsQuery, useGetGuestCartItemsQuery } from "../../../redux/APIs/cartApi";
import { selectUser } from "../../../redux/Slices/userSlice";
import useAuth from "../../../utils/Hooks/useAuth";
import CheckoutStepper from "../Checkout/subComponents/CheckoutStepper";
import PriceBreakup from "../Checkout/subComponents/PriceBreakup";
import CartItems from "./CartItems";
import EmptyCart from "./EmptyCart";

const Cart = () => {

  const isLoggedIn = useAuth();
  const user = useSelector(selectUser);

  const { data: cartItems } = useGetCartItemsQuery({skip: !isLoggedIn});
  const { data: guestCartItems } = useGetGuestCartItemsQuery();

  console.log('cartItems', cartItems)
  console.log('guestCartItems', guestCartItems)

  const data = isLoggedIn ? cartItems : guestCartItems;

  console.log('data', data);

  const isCartItems = data?.isCartItems

  console.log('isCartItems', isCartItems);



  return (
    <div className="bg-slate-100 min-h-[100dvh] hide-scrollbar sm:pt-[70px] max-sm:pt-[40px]">
      {isCartItems ? <div className="max-w-[1100px] mx-auto">
        <CheckoutStepper cartItems={data?.data?.cartItems} />
        <div className="w-full h-full max-md:flex-col max-md:gap-0 flex md:gap-2 lg:gap-8 justify-center font-bodyPhilosopher">
          <div className="flex-1">
            {data?.cartItems?.map((item) => <CartItems props={item} />)}
          </div>
          <div className="flex flex-col relative max-sm:mb-6">
            <PriceBreakup priceDetails={data?.priceDetails} />
            <div
            className="max-md:hidden  bg-white p-2 mt-2 rounded-xl sticky top-[400px]"
            
          >
            <Link
              to="/checkout/address"
              className="flex justify-center items-center no-underline w-32 h-10 md:h-12 md:w-full rounded-full bg-gradient-to-r from-red-500 to-pink-600 bg-red-700 text-white hover:scale-[102%] transition-all cursor-pointer"
            >
              Proceed
            </Link>
          </div>
          </div>
          <div
            className="max-md:sticky max-md:bottom-0 max-md:w-full flex items-center px-2 md:hidden bg-white md:mt-2 md:rounded-xl max-md:bg-white max-md:p-2 md:p-4 justify-between max-sm:bottom-[45px]"
            style={{ boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)" }}
          >
            <span>₹{data?.priceDetails?.totalAmount}</span>
            <Link
              to="/checkout/address"
              className="flex justify-center self-end items-center no-underline w-32 h-8 md:h-12 md:w-full rounded-full bg-gradient-to-r from-red-500 to-pink-600 bg-red-700 text-white hover:scale-105 transition-all cursor-pointer"
            >
              Proceed
            </Link>
          </div>
        </div>
      </div> : <EmptyCart/>}
    </div>
  );
};

export default Cart;
